// Reuse the legacy cookie name
// https://nextjs.org/docs/advanced-features/i18n-routing#leveraging-the-next_locale-cookie
export const COOKIE_LOCALE_NAME = 'NEXT_LOCALE';
// In a URL like "/en-US/about", the locale segment is "en-US"
export const LOCALE_SEGMENT_NAME = 'locale';
//# sourceMappingURL=constants.js.map